export default __webpack_public_path__ + "static/media/080_finish_bad.first.d98a4469.png";